import React from 'react';
import PropTypes from 'prop-types';

import { blank } from 'spiceutils';
import { CheckBox } from 'spicecomponents';

const IncludeBacksheets = ({
  cdf,
  updateCDF,
}) => (
  <div>
    <label htmlFor="Include Backsheets">Include PPTX backsheets</label>
    <CheckBox
      value="Yes"
      checked={blank(cdf.ExcludeBacksheets) ? false : !cdf.ExcludeBacksheets}
      onChange={(b) => onChange(b, updateCDF)}
      name="Include Backsheets"
    />
  </div>
);

const onChange = (box, updateCDF) => {
  /*
   * If box checked:
   *   Include backsheets -> ExcludeBacksheets === false
   * Box unchecked:
   *   Use default -> ExcludeBacksheets === null
   */
  if (box.checked) {
    updateCDF('ExcludeBacksheets', false);
  } else {
    updateCDF('ExcludeBacksheets', null);
  }
};

IncludeBacksheets.propTypes = {
  cdf: PropTypes.object.isRequired,
  updateCDF: PropTypes.func.isRequired,
};

export default IncludeBacksheets;



// WEBPACK FOOTER //
// ./app/components/FormControls/IncludeBacksheets/index.js